<template>
  <div>
    <div>
      <p class="contentType">
        <span>Condition Type:</span>
        <span>{{ formName }}</span>
      </p>
    </div>
    <el-form
      :model="form"
      ref="form"
      :rules="rules"
      label-position="left"
      label-width="140px"
    >
      <el-row :gutter="24">
        <el-col :xs="24" :sm="24" :md="12">
          <el-form-item label="Uplift amount:" prop="upliftAmount">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 6 }"
              maxlength="500"
              show-word-limit
              v-model="form.upliftAmount"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12">
          <el-form-item label="Valid until:" prop="validUntill">
            <el-date-picker
              valueFormat="yyyy-MM-dd"
              format="yyyy-MM-dd"
              style="width: 300px"
              v-model="form.validUntill"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <common-form ref="commonForm" :defaultData="_commonData"></common-form>
  </div>
</template>

<script>
import CommonForm from './common-form'
export default {
  components: { CommonForm },
  data() {
    return {
      formName: 'UPL',
      form: {
        upliftAmount: '',
        validUntill: '',
      },
      commonFormData: {},
      rules: {
        upliftAmount: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
        validUntill: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    _commonData() {
      return {
        ...this.commonFormData,
      }
    },
  },
  watch: {
    d_value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.commonFormData = newValue
        this.$set(this.form, 'upliftAmount', newValue.upliftAmount)
        this.$set(this.form, 'validUntill', newValue.validUntill)
      },
    },
  },
  props: {
    d_value: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormData() {
      return {
        ...this.form,
        formName: this.formName,
        ...this.$refs.commonForm.getCommonForm(),
      }
    },
    async checkValid() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        return await this.$refs.commonForm.checkCommonValid()
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped lang="less">
.contentType {
  margin-bottom: 10px;

  span {
    font-size: 14px;
    font-weight: bold;
    color: #303133;
    &:first-child {
      margin-right: 10px;
    }
  }
}
</style>
